// Presentation only. Never use these strings as transaction parameters.
export function formatAmount(value, decimals = 2) {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (!Number.isFinite(number)) return '—';
  if (number > 0 && number < 10 ** -decimals) return `<${(10 ** -decimals).toFixed(decimals)}`;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimals, maximumFractionDigits: decimals,
  }).format(number);
}

export function isAmountValid(value, balance) {
  const text = String(value ?? '');
  return /^(?:\d+(?:\.\d{0,18})?|\.\d{1,18})$/.test(text)
    && Number.isFinite(Number(text)) && Number(text) > 0
    && Number.isFinite(Number(balance)) && Number(text) <= Number(balance);
}
